import React, {FC, useEffect, useState} from "react";
import { useTask } from '../stateManagement/context';
import Typography from "@material-ui/core/Typography";
import {Button, Card, CardActions, CardContent, Grid, MenuItem, Paper, Select} from "@material-ui/core";
import {
    IAssessment,
    IControlMeasure,
    IControlMeasureFailureMode,
    IFailureMode,
    IProjectFailureMode,
    IRiskAssessment
} from "../types/types";


interface IFailureModeControlModeProps {
    failure_mode:IProjectFailureMode,
    control_measure: IControlMeasure,
    updateControlMeasure: (controlMeasureFailureMode: IControlMeasureFailureMode) => void,
    control_measure_failure_mode: IControlMeasureFailureMode,
    initial_selection_id: string
}



const FailureModesControlMeasureSelect: FC<IFailureModeControlModeProps> = ({failure_mode,
                                                                                control_measure,
                                                                                updateControlMeasure,
                                                                                control_measure_failure_mode,
                                                                                initial_selection_id}: IFailureModeControlModeProps) => {

    let tasks = useTask()

    const [write_access, setWriteAccess] = useState<boolean>(false);


    useEffect(() => {
        setWriteAccess(tasks.write_access)
    }, [tasks])
    
    useEffect(() => {
        if (selected === initial_selection_id) {
            return
        }
        setSelected(initial_selection_id)

    }, [initial_selection_id])

    const  [selected, setSelected] = useState(initial_selection_id);

    const modes = [
        {priority:0, name: "-", color: "#FFFFFF"},
        {id: 1, name: "primary",color: "#00ff00"},
        {id: 2, name:"secondary",color: "#ffff00"}]


    return (
        <div>
            <Select
                style={{fontSize:"11pt", backgroundColor: modes.find( (m) => m.id == parseInt(selected))?.color || "#FFFFFF"}}
                value={selected}
                disabled={!write_access}
                onChange={(event) => {
                    let selection = event.target.value as string
                    let priority = 0
                    if (parseInt(selection)) {
                        priority = parseInt(selection)
                    }
                    if(failure_mode.id) {
                        control_measure_failure_mode.project_failure_mode_id = failure_mode.id
                        let c = {
                            control_measure_id: control_measure.uuid,
                            project_failure_mode_id: control_measure_failure_mode.project_failure_mode_id,
                            priority: priority}
                        updateControlMeasure(c)
                    }
                    setSelected(event.target.value as string)
                }
                
                }>
                {modes.map((d) => {
                    return <MenuItem style = {{
                        backgroundColor: d.color
                    }}value={d.id}>{d.name}</MenuItem>
                })}
            </Select>
        </div>
    );
}

export default FailureModesControlMeasureSelect;
